import React, { useEffect, useState } from "react";

const ProductPage = () => {
  const [products, setProducts] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    fetch("/products.json")
      .then((res) => res.json())
      .then(setProducts)
      .catch((err) => console.error("Error loading products:", err));
  }, []);

  const handleAddToCart = (product) => {
    setSelectedProduct(product);
    setQuantity(1);
    setShowPopup(true);
  };

  const handleConfirmOrder = () => {
    if (!selectedProduct || quantity < 1) return;
    const totalPrice = (selectedProduct.price * quantity).toFixed(0);
    const message = `New Coffee Order!\n\nProduct: ${selectedProduct.title}\nOrigin: ${selectedProduct.origin || "Single origin"} (single origin)\nQuantity: ${quantity}\nPrice per unit: ${selectedProduct.price} Frw\nTotal: ${totalPrice} Frw\n\nBrewed with purpose. Shared with pride.`;
    window.open(`https://wa.me/250787255672?text=${encodeURIComponent(message)}`, "_blank");
    setShowPopup(false);
  };

  return (
    <section className="bg-cream px-5 pb-20 pt-28 md:px-8">
      <div className="mx-auto mb-14 max-w-4xl text-center">
        <p className="eyebrow">Shop</p>
        <h1 className="mt-3 font-display text-4xl text-espresso md:text-5xl">Our Coffee</h1>
        <p className="mx-auto mt-4 max-w-2xl text-cocoa">
          Single-origin Red Bourbon from Rulindo, Kamonyi, or Karongi—washed, grown at 1,500–2,000 MASL, and
          roasted medium to dark for citrus, dark chocolate, and brown sugar notes. Each lot stays true to one district.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-2 text-xs md:text-sm">
          {["Single Origin", "Rulindo", "Kamonyi", "Karongi", "Washed Process", "Red Bourbon"].map((tag) => (
            <span
              key={tag}
              className="rounded-full border border-espresso/20 px-4 py-2 font-medium text-espresso"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>

      <div className="mx-auto grid max-w-7xl gap-6 sm:grid-cols-2 xl:grid-cols-4">
        {products.map((product, index) => (
          <article
            key={index}
            className="group flex flex-col overflow-hidden rounded-2xl bg-white shadow-sm transition hover:shadow-lg"
          >
            <div className="relative aspect-square overflow-hidden bg-cream-warm p-6">
              <img
                src={product.image}
                alt={product.title}
                className="h-full w-full object-contain transition duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-display text-xl text-espresso">{product.title}</h3>
              <p className="mt-2 flex-1 text-sm text-cocoa">{product.description}</p>
              {(product.origin || product.process) && (
                <p className="mt-3 text-xs font-medium text-gold">
                  {[product.origin, product.process, product.variety].filter(Boolean).join(" · ")}
                </p>
              )}
              <div className="mt-4 flex items-center justify-between">
                <p className="font-display text-xl text-espresso">
                  {product.price.toLocaleString()} Frw
                </p>
                <button
                  type="button"
                  onClick={() => handleAddToCart(product)}
                  className="rounded-full bg-espresso px-4 py-2 text-sm font-semibold text-cream transition hover:bg-espresso-soft"
                >
                  Add to Cart
                </button>
              </div>
            </div>
          </article>
        ))}
      </div>

      {showPopup && selectedProduct && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-espresso/50 p-4"
          onClick={(e) => e.target === e.currentTarget && setShowPopup(false)}
        >
          <div className="w-full max-w-md rounded-2xl bg-cream p-6 text-center shadow-xl">
            <h2 className="font-display text-2xl text-espresso">Confirm Order</h2>
            <p className="mt-2 font-medium text-cocoa">{selectedProduct.title}</p>
            <label className="mt-4 block text-sm font-medium text-espresso">Quantity</label>
            <input
              type="number"
              min="1"
              value={quantity}
              onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value, 10) || 1))}
              className="mt-2 w-full rounded-lg border border-cream-muted bg-white px-3 py-2 text-center outline-none focus:border-gold"
            />
            <p className="mt-4 font-display text-xl text-espresso">
              Total: {(selectedProduct.price * quantity).toLocaleString()} Frw
            </p>
            <div className="mt-6 flex justify-center gap-3">
              <button
                type="button"
                onClick={() => setShowPopup(false)}
                className="rounded-full border border-cream-muted px-5 py-2 text-sm font-semibold"
              >
                Cancel
              </button>
              <button type="button" onClick={handleConfirmOrder} className="btn-primary">
                Confirm on WhatsApp
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductPage;
